var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#007AFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6088 9.59994L8.75476 13.8173L11.9741 15.1546C12.915 15.5451 13.6625 16.2929 14.0528 17.2339L15.3901 20.4526L19.6088 9.59994ZM20.8401 10.0546L16.6215 20.9086C16.3548 21.5953 15.5874 21.9466 14.9074 21.6953C14.7417 21.6342 14.5904 21.5395 14.463 21.417C14.3357 21.2946 14.235 21.1472 14.1674 20.9839L12.8294 17.7639C12.5688 17.137 12.0705 16.6389 11.4434 16.3786L8.22476 15.0413C7.55543 14.7633 7.2501 13.9906 7.54276 13.3146C7.61466 13.1494 7.71853 13 7.84839 12.875C7.97825 12.7501 8.13154 12.6521 8.29943 12.5866L19.1535 8.36794C19.3893 8.27318 19.6477 8.24979 19.8967 8.30068C20.1457 8.35158 20.3742 8.47451 20.5539 8.6542C20.7336 8.83389 20.8565 9.06242 20.9074 9.3114C20.9583 9.56037 20.9349 9.81881 20.8401 10.0546Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGps);
export default __webpack_public_path__ + "static/media/GPS.9effa83b8b9fef1486a47e774a200f79.svg";
export { ForwardRef as ReactComponent };